import '@/user/common';
import '@/shared/page/weddingdata/_index';
$(() => {
    /**
     * 表示項目の切替
     */
    $(window).on('load hashchange', () => {
        const type = location.hash.replace('#', ''); // アンカーリンクからタイプを取得URLを置換
        const $items = $('.facility-place');

        if (type.length > 0) {
            if ($items.filter(`.${type}`).length > 0) {
                // タイプが存在したら絞り込み、該当ページを表示
                $items.filter(`:not(.${type})`).hide();
                $items.filter(`.${type}`).show();
            } else {
                // 該当タイプがない場合全表示
                location.hash = '#all';
                $items.show();
            }
        }
    });
});

